module.exports = __webpack_public_path__ + "img/HZ-S4036.1f4a1b04.jpg";